import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { VenueProvider } from './contexts/VenueContext';
import { GlobalSettingsProvider } from './contexts/GlobalSettingsContext';
import { LanguageProvider } from './contexts/LanguageContext';

// SEO Injection
import SEOHead from './components/SEOHead';

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import Dashboard from './pages/Dashboard';
import VenuePage from './pages/VenuePage';
import SubscriptionPage from './pages/SubscriptionPage';
import ReservationsPage from './pages/ReservationsPage';
import WidgetSettingsPage from './pages/WidgetSettingsPage';
import SettingsPage from './pages/SettingsPage';
import BankSettingsPage from './pages/BankSettingsPage';
import SearchResultsPage from './pages/SearchResultsPage';
import VenuePricingPage from './pages/VenuePricingPage';
import BookingWidget from './components/BookingWidget';
import PublicBookingPage from './pages/PublicBookingPage';
import AdminPage from './pages/AdminPage';
import ProtectedRoute from './components/ProtectedRoute';

import './App.css';

function App() {
  return (
    <LanguageProvider>
      <GlobalSettingsProvider>
        <AuthProvider>
          <SubscriptionProvider>
            <VenueProvider>
              <Router>
                <div className="min-h-screen bg-gray-50">
                  {/* DYNAMIC SEO INJECTION */}
                  <SEOHead />
                  
                  <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/signup" element={<SignupPage />} />
                    <Route path="/search" element={<SearchResultsPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/widget/:clientId/:venueId" element={<BookingWidget />} />
                    <Route path="/book/:clientId/:venueId" element={<PublicBookingPage />} />
                    <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                    <Route path="/venue/:id" element={<ProtectedRoute><VenuePage /></ProtectedRoute>} />
                    <Route path="/venue-pricing/:id" element={<ProtectedRoute><VenuePricingPage /></ProtectedRoute>} />
                    <Route path="/subscription" element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>} />
                    <Route path="/reservations" element={<ProtectedRoute><ReservationsPage /></ProtectedRoute>} />
                    <Route path="/widget-settings" element={<ProtectedRoute><WidgetSettingsPage /></ProtectedRoute>} />
                    <Route path="/bank-settings" element={<ProtectedRoute><BankSettingsPage /></ProtectedRoute>} />
                    <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
                  </Routes>
                </div>
              </Router>
            </VenueProvider>
          </SubscriptionProvider>
        </AuthProvider>
      </GlobalSettingsProvider>
    </LanguageProvider>
  );
}

export default App;